import * as React from "react";
const SvgFiRrBenefitPorcent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-benefit-porcent_svg__a)">
      <path
        fill="#062147"
        d="M11.5 6a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 11.5 6m-6-3a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 5.5 3m17.736 10.015-6.805 7.637A10 10 0 0 1 8.965 24H4c-2.206 0-4-1.794-4-4v-5c0-2.206 1.794-4 4-4h8.858c1.139 0 2.138.609 2.689 1.518l3.216-3.534a3 3 0 0 1 2.086-.981 2.96 2.96 0 0 1 2.168.782 3.02 3.02 0 0 1 .219 4.229zm-1.566-2.751a1.04 1.04 0 0 0-.728-.262c-.27.013-.518.129-.7.329l-4.426 4.864a3.16 3.16 0 0 1-2.514 2.059l-5.161.737a1 1 0 1 1-.283-1.979l5.161-.737c.559-.08.981-.566.981-1.131 0-.63-.512-1.142-1.142-1.142H4c-1.103 0-2 .897-2 2v5c0 1.103.897 2 2 2h4.965a8 8 0 0 0 5.973-2.678l6.805-7.638a1.016 1.016 0 0 0-.073-1.421zM5.71 8.842a1 1 0 0 0 1.382-.3l4.499-7.001A1 1 0 0 0 9.908.46l-4.5 7a1 1 0 0 0 .302 1.382"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-benefit-porcent_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBenefitPorcent;
